export default __webpack_public_path__ + "static/media/CapaLogoWhite.46fe887b.svg";